import { Avatar, IconButton, Tooltip, Type, Typography, type IColumn } from 'shared/ui'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { EmptyCell } from 'shared/ui/Table'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'
import { type IContactStatistic } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/store/HubspotWorkflowViewStore'
import styles from './styles.module.scss'

export const getColumns = (onOpenContactsDetails: IOpenContactsDetails) => {
  const nameColumn: IColumn<IContactStatistic> = {
    field: 'full_name',
    name: 'Name',
    width: '362px',
    minWidth: '362px',
    maxWidth: '362px',
    renderRowCell: (row, _, config) => {
      if (!row) return null
      return (
        <div className={styles.contactColumn}>
          <div className={styles.contactColumnName}>
            {row.avatarInfo && <Avatar info={row.avatarInfo} size={24} />}
            <Typography
              variant={'body-md-regular'}
              ellipsis
              tooltipProps={{ label: row.full_name }}
              ariaLabel={'ContactName'}
            >
              {row.full_name || '—'}
            </Typography>
          </div>
          <Tooltip label='Conversation' placement='top'>
            <IconButton
              icon='conversation'
              variant='icon'
              color='tertiary'
              transparentInactive
              className={config?.hidden}
              ariaLabel='ContactRow_sendMessage'
              disabled={onOpenContactsDetails.disabled}
              onClick={(event) => {
                event.stopPropagation()
                onOpenContactsDetails.open({
                  contactId: row.id,
                  inboxId: row.team_id,
                  numberId: row.number_id,
                })
              }}
            />
          </Tooltip>
        </div>
      )
    },
  }

  const numberColumn: IColumn<IContactStatistic> = {
    field: 'number',
    name: 'Phone',
    renderRowCell: (row) =>
      row.number ? (
        <span aria-label='ContactNumber'>{getLabelAsNumberInternationalFormat(row.number)}</span>
      ) : (
        <EmptyCell />
      ),
  }

  const emailColumn: IColumn<IContactStatistic> = {
    field: 'email',
    name: 'Email',
    renderRowCell: (row) => row.email ?? <EmptyCell />,
  }

  const typeColumn: IColumn<IContactStatistic> = {
    field: 'type',
    name: 'Type',
    renderRowCell: () => <Type type={'sms'} />,
  }

  const messageColumn: IColumn<IContactStatistic> = {
    field: 'body',
    name: 'Message body',
    renderRowCell: (row) => (
      <div className={styles.messageBodyWrap}>
        <Typography
          variant={'body-md-regular'}
          ellipsis
          tooltipProps={{ label: row.body }}
          ariaLabel={'message'}
        >
          {row.body ?? <EmptyCell />}
        </Typography>
      </div>
    ),
  }

  const sendTimeColumn: IColumn<IContactStatistic> = {
    field: 'sent_at',
    name: 'Send time',
    renderRowCell: (row) =>
      row.sent_at ? (
        <span aria-label='ContactSendTime'>
          {uiStore.dayjs(row.sent_at).format(DayjsFormats.fullWithAtDash2)}
        </span>
      ) : (
        <EmptyCell />
      ),
  }

  return [nameColumn, numberColumn, emailColumn, typeColumn, messageColumn, sendTimeColumn]
}
